import { render, staticRenderFns } from "./HowItWorkPayout.vue?vue&type=template&id=ecebd06e&"
import script from "./HowItWorkPayout.vue?vue&type=script&lang=js&"
export * from "./HowItWorkPayout.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorkPayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports